module.exports = __webpack_public_path__ + "img/games.51992a45.svg";